import { EmailClient, getEffectiveEmailClient } from "client_legacy/Email/emailClient";
import { ReactElement, useEffect } from "react";
import { NewEmailNotificationDataViewModel } from "client/Api/Notifications/notifications";

export type NewEmailActivityInvocationProps = {
	data: NewEmailNotificationDataViewModel;
	onDismiss: () => void;
};

export const NewEmailActivityInvocation = (props: NewEmailActivityInvocationProps): ReactElement | null => {
	const {
		data,
		onDismiss
	} = props;

	useEffect(
		() => {
			const emailClient: EmailClient = getEffectiveEmailClient();

			if (emailClient.supportsNavigateToEmail) {
				emailClient.navigateToEmail({
					emailId: data.exchangeId
				});
			} else {
				console.error("Unable to navigate to e-mail because current client does not support navigation");
			}

			onDismiss();
		},
		[data.exchangeId, onDismiss]
	);

	return null;
};

NewEmailActivityInvocation.displayName = "NewEmailActivityInvocation";